// The one specialties list (IW-3). Instructors pick from it on their profile, and the marketplace
// filters on it, so a specialty a student can filter by is always one an instructor can choose.
// Specialties typed before the list existed stay on the profile but match no filter.
export const SPECIALTIES = ['Conversational', 'JLPT prep', 'HSK prep', 'Business', 'Kids', 'Pop culture', 'Pronunciation'];

// The "Teaches children" filter keeps instructors who picked this specialty.
export const KIDS_SPECIALTY = 'Kids';

// True when `name` is on the list exactly. Matching is case-sensitive on purpose: a typed
// "jlpt prep" is not the listed "JLPT prep", so it never satisfies a filter.
export function isListedSpecialty(name) {
  return SPECIALTIES.includes(name);
}
